import { render, staticRenderFns } from "./UserVerify.vue?vue&type=template&id=6b4d5072&"
import script from "./UserVerify.vue?vue&type=script&lang=js&"
export * from "./UserVerify.vue?vue&type=script&lang=js&"
import style0 from "./UserVerify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports